import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type InterviewFetchFailedAction = {
	type: 'INTERVIEW_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): InterviewFetchFailedAction => ({
	type: 'INTERVIEW_FETCH_FAILED',
	payload,
});
